import React from 'react';
import PropTypes from 'prop-types';
import { PropsContext } from '@uhg-abyss/web/hooks/usePropsContext/PropsContext';
import { AppSearchSelect } from './AppSearchSelect';
import { ThemeProvider } from '@uhg-abyss/web/ui/ThemeProvider';
import { createTheme } from '@uhg-abyss/web/tools/theme';
const theme = createTheme('uhc', { enterpriseFont: true });

export const Widget = (props) => {
  const widgetProps = { ...props };
  return (
    <ThemeProvider theme={theme}>
      <PropsContext.Provider value={widgetProps}>
        <AppSearchSelect {...props} />
      </PropsContext.Provider>
    </ThemeProvider>
  );
};

Widget.displayName = 'utility/AppSearch';

Widget.propTypes = {
  data: PropTypes.shape({
    title: PropTypes.string,
    userPermissions: PropTypes.shape({}),
  }),
  onItemSelect: PropTypes.func,
};

Widget.defaultProps = {
  data: {
    title: 'App Search',
    userPermissions: {},
  },
  onItemSelect: () => null,
};
